import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'appDate'
})
export class AppDatePipe implements PipeTransform {

	transform(value: Date | string | number, locale: string = navigator.language): unknown {
		if (!value) return '';

		try {
			const date = new Date(value);
			return new Intl.DateTimeFormat(locale).format(date);
		} catch (error) {
			console.error('Invalid date:', value);
			return value.toString();
		}
	}

}
